import { useGenericContext } from "../../hooks";
import { TerritoryContext } from "./TerritoryContext";

export const useTerritories = () => useGenericContext(TerritoryContext);
